<template>
  <section class="container-sm">
    <h2 class="text-center">Reportar Abuso o Bullying</h2>

    <div v-if="numeroConsulta" class="row mb-4 text-center mt-4">
      <div class="col-lg-12">
        <div class="alert alert-info" role="alert">
          ¡Gracias por hacer tu consulta! <br />
          Tu número de consulta es:
          {{ numeroConsulta }}
        </div>
      </div>
    </div>
    <div v-if="numeroConsulta == null" class="m-4">
      <div class="row mb-4 text-center mt-4">
        <div class="col-lg-12">
          <div class="alert alert-warning" role="alert">
            Por favor complete el formulario a continuación.
          </div>
        </div>
      </div>
      <h4 class="text-warning text-center">Tu denuncia es procesado de forma privada.</h4>
      <hr>
      <form @submit.prevent="enviarFormulario">
        <div class="row justify-content-center">
          <div class="form-group col-12 mb-3">
            <strong><label>Apellido y Nombre:</label></strong>
            <input class="form-control" v-model="apellido" type="text" data-rule-required="true" aria-required="true"
              required />
            <p v-if="!apellidoValido" class="error-message">
              Por favor ingrese su Apellido y Nombre.
            </p>
          </div>
          <div class="form-group col-12 mb-3">
                <strong><label for="tipo">Tipo de incidente:</label></strong>
                <select id="tipo" name="tipo" required class="form-control">
                    <option value="" disabled selected>Seleccione una opción</option>
                    <option value="Bullying">Bullying / Acoso</option>
                    <option value="Abuso">Abuso de autoridad</option>
                    <option value="cyberbullying">Ciberacoso</option>
                    <option value="Otro">Otro</option>
                </select>
            </div>
          <div class="form-group col-12 mb-3">
            <strong><label>E-Mail:</label></strong>
            <input class="form-control" v-model="email" type="email" data-rule-email="true" required />
            <p v-if="!emailValido" class="error-message">
              Por favor ingrese un correo electrónico válido. 
            </p>
          </div>
          <div class="col-12 form-group mb-3">
            <strong><label>Consulta:</label></strong>
            <textarea class="form-text col-12 border rounded-5 p-4" v-model="mensaje" rows="12" data-rule-required="true"
              aria-required="true" required></textarea>
            <p v-if="!consultaValida" class="error-message">
              Por favor ingrese su consulta, reclamos o sugerencias.
            </p>
          </div>
          <div class="col-12 form-group mb-3">
            <strong><label>Teléfono</label></strong>
            <input class="form-control" v-model="telefono" type="number" data-rule-required="true" aria-required="true"
              required />
            <p v-if="!telefonoValido" class="error-message">
              Por favor ingrese un número de teléfono válido.
            </p>
          </div>
          <button class="btn btn-warning text-uppercase m-3 col-4" type="submit">
            Enviar
          </button>
        </div>
      </form>
    </div>
  </section>
</template>
  
<script>
import axios from "axios";

export default {
  name: "FormComponent",
  data() {
    return {
      hash: "FC",
      items: null,
      title: null,
      links: null,
      urlServicio: "",
      telefono: "",
      email: "",
      apellido: "",
      mensaje: "",
      tipo: "",
      numeroConsulta: null,
      apellidoValido: true,
      emailValido: true,
      consultaValida: true,
      telefonoValido: true,
    };
  },
  methods: {
    enviarFormulario() {
      this.resetErrores();
      if (!this.validarCampos()) {
        return;
      }
      let apellido = this.apellido;
      let telefono = this.telefono;
      let email = this.email;
      let mensaje = `Tipo: ${this.tipo} - Mensaje: ${this.mensaje} - Desde el sitio: ${window.location.origin}`;
      let urlServicio = `https://sanjuan.gob.ar/ol/?or=B37192BB31334445B548D5B82CF88B2B&Apellido=${apellido}&email=${email}&Consulta=${mensaje}&Telefono=${telefono}`;
      axios
        .get(urlServicio)
        .then((response) => {
          this.numeroConsulta = response.data.res[0]["Consulta N° "];
        })
        .catch((error) => {
          console.error("Error al enviar el formulario:", error);
        });
    },
    validarCampos() {
      let camposValidos = true;
      if (!this.apellido || !/^[A-Za-z]+(\s[A-Za-z]+)*$/.test(this.apellido)) {
        this.apellidoValido = false;
        camposValidos = false;
      }

      if (
        !this.email ||
        !this.validarEmail(this.email) ||
        this.email.trim() === ""
      ) {
        this.emailValido = false;
        camposValidos = false;
      }

      if (!this.mensaje) {
        this.mensajeValida = false;
        camposValidos = false;
      }
      const telefonoString = String(this.telefono).trim();
      if (
        !telefonoString ||
        telefonoString === "" ||
        !/^\d+$/.test(telefonoString)
      ) {
        this.telefonoValido = false;
        camposValidos = false;
      }

      return camposValidos;
    },
    validarEmail(email) {
      // Expresión regular para validar el formato de correo electrónico
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    resetErrores() {
      this.apellidoValido = true;
      this.emailValido = true;
      this.mensajeValida = true;
      this.telefonoValido = true;
    },
  },
};
</script>
<style>
.error-message {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}
</style>